module.exports = __webpack_public_path__ + "img/pitch-background.fa0ee2ce.jpg";